import React from 'react';
import ClientProfile from './ClientProfile';
import TabNavigation from './TabNavigation';
import WidgetToolbar from './WidgetToolbar';
import WidgetGrid from './WidgetGrid';
import EmptyState from './EmptyState';

const ClientInsightsTab = ({ 
  selectedClient, 
  clients, 
  onClientChange, 
  activeClientTab, 
  tabs, 
  widgets, 
  widgetContents, 
  handleWidgetContentChange, 
  deleteWidget, 
  selectedUseCase,
  editingTabId,
  editingTabName,
  editTabInputRef,
  handleTabDoubleClick,
  handleTabNameKeyDown,
  handleTabNameSave,
  hoveredTab,
  setHoveredTab,
  handleClientTabChange,
  handleDeleteTab,
  setShowPopup,
  setEditingTabName
}) => {
  if (!selectedClient) {
    return <EmptyState message="No client selected" />;
  }

  return (
    <>


      <WidgetToolbar
        activeClientTab={activeClientTab}
        setShowPopup={setShowPopup}
      />

      {activeClientTab ? (
        <WidgetGrid
          widgets={widgets}
          activeClientTab={activeClientTab}
          selectedClient={selectedClient}
          widgetContents={widgetContents}
          handleWidgetContentChange={handleWidgetContentChange}
          deleteWidget={deleteWidget}
          selectedUseCase={selectedUseCase}
        />
      ) : (
        <EmptyState 
          message="No tab selected" 
          buttonText="Create New Tab"
          onButtonClick={() => setShowPopup(true)}
        />
      )}
    </>
  );
};

export default ClientInsightsTab;